import {Button, Divider, Grid, TextField, Typography} from '@material-ui/core';
import * as HT from 'ApplicationEntry/ducks/hippaTrustees';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {HippaTrustees} from 'ApplicationEntry/models/HippaTrustees';
import React from 'react';
import {useDispatch} from 'react-redux';
import './HippaTrustees.sass';

type HippaTrusteesProps = {
  hippaTrustees: HippaTrustees;
  applicationType: string;
};

const HippaTrusteeSection = (props: HippaTrusteesProps) => {
  const trusteeList = props.hippaTrustees;
  const dispatch = useDispatch();
  const applicationType = props.applicationType;
  if (applicationType === ApplicationType.Ordinary || applicationType === ApplicationType.NewYork) {
    return (
      <form noValidate autoComplete="off" className="hippa-trustee-section">
        <div className="hippa-trustee-section__title-container">
          <Typography variant="subtitle2" className="hippa-trustee-section__title-container-title">
            HIPAA Trustee
          </Typography>
        </div>
        
        <Grid container spacing={4} alignItems="center">
          {trusteeList.trustees.map((trustee, index) => {
            return (
              <Grid item md={6} xs={12} key={`trustee${index}`}>
                <Grid container spacing={4} alignItems="center">
                  <Grid item xs={12} className="hippa-trustee-section__sub-title-container">
                    <Typography variant="subtitle1" className="hippa-trustee-section__sub-title-container-title">Trustee {index + 1}</Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="first-name"
                      label="First Name"
                      variant="outlined"
                      placeholder="First Name"
                      margin="normal"
                      fullWidth
                      className="hippa-trustee-section__text-field"
                      value={trustee.firstName}
                      onChange={e => dispatch(HT.changeFirstName(e.target.value as string, index))}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      id="last-name"
                      label="Last Name"
                      variant="outlined"
                      placeholder="Last Name"
                      margin="normal"
                      fullWidth
                      className="hippa-trustee-section__text-field"
                      value={trustee.lastName}
                      onChange={e => dispatch(HT.changeLastName(e.target.value as string, index))}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => dispatch(HT.deleteTrustee(index))}
                      className="hippa-trustee-section__delete"
                    >
                      Remove Trustee
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>

        {trusteeList.trustees.size < 10 ? (
          <Grid container className="hippa-trustee-section__add-container" direction="row" justify="center" alignItems="center">
            <Button
              variant="contained"
              color="primary"
              onClick={() => dispatch(HT.addTrustee())}
              className="hippa-trustee-section__add-container-button"
            >
              <Typography variant="h6">+</Typography>
              Additional Trustee
            </Button>
          </Grid>
        ) : null}
        <Divider className="application-form__actions-divider" />
      </form>
    );
  }
  return <></>;
};

export default HippaTrusteeSection;
